module.exports = __webpack_public_path__ + "static/img/福華台中.0a8be33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/福華台中.png?20181011
// module id = VD7l
// module chunks = 1